"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontAwesomeIcon = exports.readOnly = exports.checkedIcon = exports.uncheckedIcon = exports.visible = exports.hidden = exports.search = exports.FontAwesomeLibrary = void 0;
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const fontawesome_svg_core_1 = require("@fortawesome/fontawesome-svg-core");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const react_1 = __importDefault(require("react"));
const icons = [
    pro_solid_svg_icons_1.faCheck,
    pro_regular_svg_icons_1.faCheckSquare,
    pro_solid_svg_icons_1.faChevronDoubleLeft,
    pro_solid_svg_icons_1.faChevronDoubleRight,
    pro_solid_svg_icons_1.faChevronDown,
    pro_solid_svg_icons_1.faChevronLeft,
    pro_solid_svg_icons_1.faChevronRight,
    pro_solid_svg_icons_1.faChevronUp,
    pro_solid_svg_icons_1.faCircle,
    pro_solid_svg_icons_1.faClipboard,
    pro_solid_svg_icons_1.faClipboardCheck,
    pro_solid_svg_icons_1.faCube,
    pro_solid_svg_icons_1.faEdit,
    pro_solid_svg_icons_1.faEye,
    pro_solid_svg_icons_1.faEyeSlash,
    pro_solid_svg_icons_1.faFish,
    pro_solid_svg_icons_1.faHomeAlt,
    pro_solid_svg_icons_1.faLock,
    pro_solid_svg_icons_1.faPencil,
    pro_solid_svg_icons_1.faPhone,
    pro_solid_svg_icons_1.faSearch,
    pro_solid_svg_icons_1.faSlash,
    pro_regular_svg_icons_1.faSquare,
    pro_solid_svg_icons_1.faStar,
    pro_solid_svg_icons_1.faStickyNote,
    pro_solid_svg_icons_1.faTimes,
    pro_solid_svg_icons_1.faTools,
    pro_solid_svg_icons_1.faTrash,
    pro_solid_svg_icons_1.faUsersSlash,
    pro_solid_svg_icons_1.faUnlock,
    pro_solid_svg_icons_1.faInfoCircle,
    pro_solid_svg_icons_1.faFileUpload
];
icons.forEach(icon => fontawesome_svg_core_1.library.add(icon));
exports.FontAwesomeLibrary = fontawesome_svg_core_1.library;
exports.search = react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "search" });
exports.hidden = react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "eye-slash" });
exports.visible = react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "eye" });
exports.uncheckedIcon = react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: ["far", "square"] });
exports.checkedIcon = react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: ["far", "check-square"] });
exports.readOnly = (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "pencil" }),
    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "slash" })));
exports.FontAwesomeIcon = react_fontawesome_1.FontAwesomeIcon;
//# sourceMappingURL=FontAwesome.js.map